var map = {
	"./QQ.svg": "0476",
	"./出库审核-已开启.svg": "fe8b",
	"./出库审核-未开启.svg": "0b91",
	"./列列表-未选.svg": "5b51",
	"./列列表-选.svg": "eae1",
	"./发货确认-已开启.svg": "ea11",
	"./发货确认-未开启.svg": "af3f",
	"./审核-不可调整.svg": "4cc9",
	"./审核-已开启.svg": "c45e",
	"./审核-未开启.svg": "fac6",
	"./必填.svg": "7bd1",
	"./提交订单.svg": "0c2a",
	"./收款确认-已开启.svg": "05ae",
	"./收款确认-未开启.svg": "3a8b",
	"./收货确认-已开启.svg": "3490",
	"./收货确认-未开启.svg": "ef86",
	"./方块列表-未选.svg": "ceac",
	"./方块列表-选.svg": "78c2",
	"./旺旺.svg": "712d",
	"./横列表-未选.svg": "8b3e",
	"./横列表-选.svg": "b52f",
	"./电话.svg": "542b",
	"./系统首页-客户.svg": "0f8e",
	"./系统首页-订单.svg": "b6a5",
	"./系统首页-购物.svg": "d3da",
	"./系统首页-金额.svg": "b736",
	"./订单审核.svg": "6703",
	"./财务审核-已开启.svg": "0cb3",
	"./财务审核-未开启.svg": "c6e1",
	"./退款确认-已开启.svg": "c1bb",
	"./退款确认-未开启.svg": "feb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ff";